import React from 'react';
import { Logo, Container, Row } from '..';
import { Col } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import styles from './styles.module.css';
import * as PATHS from '../../settings/paths';
import * as Icon from '../Icons';

const index = () => {
  return (
    <div className={styles.footer}>
      {/* <div className={styles.logoBg}></div> */}
      <Container>
        <Row between style={{ marginBottom: '2rem' }}>
          <div className={styles.logo}>
            <Logo color={"colored"} height="60px" />
          </div>
          <div className={styles.links}>
            {[
              { name: 'Privacy Policy', path: PATHS.PRIVACY_POLICIES },
              { name: 'Terms and Conditions', path: PATHS.TERMS_AND_CONDITIONS },
              { name: 'Contact Us', path: PATHS.CONTACT_US },
              { name: 'About Us', path: PATHS.ABOUT_US },
            ].map((item, index) => (
              <li>
                <Link to={item.path}>{item.name}</Link>
              </li>
            ))}
          </div>
          <div className={styles.rightContent}>
            <div className={styles.section}>
              <h3>Planning a holiday just got easier.</h3>
              <p>A few clicks and you’re done! Download our app now.</p>
            </div>
            <div>
              <img src={'./assets/images/mobile-apps.png'} alt="mobile-app-icons" />
            </div>
          </div>
        </Row>
        <Row>
          <Col lg={8} xs={12} style={{padding:0}}>
            <ul className={styles.socials}>
              <li><Icon.Facebook /> </li>
              <li><Icon.Twitter /></li>
              <li><Icon.İnstagram /></li>
            </ul>
          </Col>
          <Col lg={4} xs={12} style={{padding:0}}>
            <img src={'./assets/images/payment-icons.png'} alt="payment-icons" className={styles.paymentImage} />
          </Col>
        </Row>
        <Row>
          <div className={styles.copyright}>
            <p>
              © {new Date().getFullYear()} <span style={{ color: 'var(--color-gold)' }}>Hodhod</span> - All Rights Reserved. Made by ideall
              technology
            </p>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default index;
